<template>
  <div class="classic-case-wrapper">
    <div class="title">
      <div class="main_title">{{ $t('cooperation.mainTitle') }}</div>
      <div class="sub-title">{{ $t('cooperation.subTitle') }}</div>
    </div>

    <div class="outer-wrapper">
      <div class="content">
        {{ $t('cooperation.content') }}
      </div>
    </div>

    <div class="com-logo" v-for="(row, rowIndex) in logoRows" :key="`row-${rowIndex}`">
      <div class="logo" :class="{ last: index === row.length - 1 }" v-for="(logo, index) in row" :key="logo.src + index">
        <img :src="logo.src" :alt="logo.alt" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CooperationBrands',
  data() {
    return {
      logoRows: [
        [
          { src: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/bf6da26b-82ed-4824-b81a-b382acf04487.png', alt: '中移铁通' },
          { src: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/5e561419-0ae3-4cdf-9b92-ad596c8da16a.png', alt: '中国联通' },
          { src: require('@/static/image/index-coop5.png'), alt: '中国电信' },
          { src: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/575b8fe3-f6fd-4602-9984-fddbcd605e21.png', alt: '新奥集团' },
          { src: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/a7226c92-3d7c-46d4-8f17-52c369054a38.png', alt: '中国邮政' }
        ],
        [
          { src: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/bcfe22b8-3214-4b8d-9209-e70be6a1106c.png', alt: '湖南钢铁集团' },
          { src: require('@/static/image/index-coop3.png'), alt: '国家电网' },
          { src: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/16b13ce2-dc4d-43a0-9623-9c85cb628c4c.png', alt: '中国大唐集团' },
          { src: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/9ebbd284-232f-48b2-847d-c36f827e1b98.png', alt: '中国电建' },
          { src: require('@/static/image/index-coop6.png'), alt: '中国铁建重工集团' }
        ]
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.classic-case-wrapper {
  position: relative;
  height: 740px;
  // padding-top: 20px;
  box-sizing: border-box;
  background: url('~@/static/image/index-hzpp.png') no-repeat center;
  background-size: cover;

  .title {
    text-align: center;

    .sub-title {
      font-size: 46px;
      line-height: 1;
      color: #333;
    }

    .main_title {
      margin-top: 8px;
      font-size: 72px;
      line-height: 1;
      color: #d4d4d6;
      font-weight: 700;
    }
  }

  .outer-wrapper {
    width: 960px;
    height: 234px;
    margin: 64px auto 0;
    background-color: #ffffff;
    box-sizing: border-box;
    padding: 53px 60px;

    .content {
      font-size: 16px;
      color: #333333;
      line-height: 32px;
      text-align: left;
    }
  }

  .com-logo {
    width: 960px;
    margin: 22px auto 0;
    height: 110px;

    .logo {
      background-color: #ffffff;
      float: left;
      width: 110px;
      height: 110px;
      border-radius: 50%;
      margin-right: 102.5px;
      box-shadow: 0 1px 0 rgba(0, 0, 0, 0.02);
      position: relative;

      &.last {
        margin-right: 0;
      }

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -38px;
        margin-left: -38px;
        width: 76px;
        height: 76px;
        object-fit: contain;
      }
    }
  }
}
</style>
